/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Period_MonthInputs */



/**
* | output |
* | --- |
* | "month" |
*
* @param {Signup_Period_MonthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_period_month = /** @type {((inputs?: Signup_Period_MonthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Period_MonthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("month")
	if (locale === "de") return /** @type {LocalizedString} */ ("month")
	if (locale === "it") return /** @type {LocalizedString} */ ("month")
	if (locale === "ru") return /** @type {LocalizedString} */ ("month")
	if (locale === "es") return /** @type {LocalizedString} */ ("month")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("month")
	if (locale === "ja") return /** @type {LocalizedString} */ ("month")
	if (locale === "hi") return /** @type {LocalizedString} */ ("month")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("month")
	return /** @type {LocalizedString} */ ("month")
});